import { useEffect, useState } from 'react';
import { getSession, onSessionChange, type Session } from '../lib/session';

export function useSession(): Session | null {
  const [session, setSession] = useState<Session | null>(() => getSession());
  useEffect(() => onSessionChange(setSession), []);
  return session;
}
